// extracted by mini-css-extract-plugin
export default {"links":"_1yyW7J_","linksItem":"WZyJutN"};